import { render } from "./MsComboBoxItem.vue?vue&type=template&id=8335b026"
import script from "./MsComboBoxItem.vue?vue&type=script&lang=js"
export * from "./MsComboBoxItem.vue?vue&type=script&lang=js"

import "./MsComboBoxItem.vue?vue&type=style&index=0&id=8335b026&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__